module.exports = __webpack_public_path__ + "static/media/gitter.038047a6.svg";